module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [(!_vm.hasMarathonStarted) ? _c('div', {
    staticClass: "marathon-countdown"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$root.marathon.name) + " starts in...")]), _vm._v(" "), _c('Timer'), _vm._v(" "), _c('div', {
    staticClass: "start-date"
  }, [_vm._v(_vm._s(_vm.$root.marathon.starts))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.marathon.mode == "marathon") ? _c('div', {
    attrs: {
      "id": "marathon_stream"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "marathon-info"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "hero has-text-centered"
  }, [_c('div', {
    staticClass: "hero-container"
  }, [_c('h2', [_vm._v("What is Tomb Raider Marathon?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$root.marathon.mode !== "post-marathon") ? [_c('h3', [_vm._v(_vm._s(_vm.$root.marathon.name))]), _vm._v(" "), _c('p', [_vm._v("\n              Join us on\n              "), _c('b', [_vm._v(_vm._s(_vm.$root.marathon.starts))]), _vm._v(", for our seventh marathon, "), _c('b', [_vm._v(_vm._s(_vm.$root.marathon.name))]), _vm._v("! This time we'll be raising for\n              "), _c('a', {
    attrs: {
      "href": _vm.$root.marathon.charity_url,
      "target": "_blank"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.marathon.charity))])])])] : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "marathon-video"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "hero has-text-centered"
  }, [_c('div', {
    staticClass: "hero-container"
  }, [_c('h2', [_vm._v("Tomb Raider Marathon VII Collection")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": ((_vm.$root.marathon.latestVideo) + "&parent=" + _vm.twitchEmbedParent),
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.twitch.tv/?channel=tombraidermarathon",
      "frameborder": "0",
      "allowfullscreen": "true",
      "scrolling": "no",
      "height": "480",
      "width": "70%"
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "frameborder": "0",
      "scrolling": "yes",
      "height": "480",
      "width": "29%",
      "id": "tombraidermarathon",
      "src": "https://www.twitch.tv/embed/tombraidermarathon/chat"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Tomb Raider Marathon is a live stream gaming event where we play\n            through many of the Tomb Raider games both casually and super\n            quickly to raise money for charity. We have raised\n            "), _c('b', [_vm._v("$12,675.41‬")]), _vm._v(" since April 2017.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "marathon-finished"
  }, [_vm._v("\n            Tomb Raider Marathon VII raised\n            "), _c('b', [_vm._v("$2,450.00")]), _vm._v(", which surpassed our goal of $1,500!\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fe3f38c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeView/index.vue
// module id = 233
// module chunks = 1